import { z } from 'zod';
/** Not a preference key: the route answers for two of them and rejects the rest in the handler. */
export const PracticePreferenceOptionsParamsSchema = z
    .object({
    preferenceKey: z.string().min(1),
})
    .strict();
export const PracticePreferenceOptionsQuerySchema = z
    .object({
    // `min(1)` because joi rejects the empty string on a `Joi.string()`.
    query: z.string().min(1).optional(),
})
    .strict();
//# sourceMappingURL=options.js.map